// extracted by mini-css-extract-plugin
export default {"newExpensePopover":"NewExpensePopover_newExpensePopover__PBoXp"};